
import { Component, Mixins } from "vue-property-decorator";
import { IItem, ISourceEditable } from "../../../../../domain/document/items";
import { default as ForegroundDrawableObjectMixin } from "./ForegroundDrawableObjectMixin.vue";

@Component
export default class SourceEditableObjectMixin extends Mixins(ForegroundDrawableObjectMixin) {
  writePropertyWhenValid: (write: (s: ISourceEditable) => void) => void;
  readPropertyOrDefault: <T>(read: (s: ISourceEditable) => T, defaultValue: T) => T;

  writeSourcePropertyWhenValid(write: (s: IItem) => void): void {
    this.writePropertyWhenValid(s => {
      if (s.source) {
        const cloned = s.source.clone() as  IItem;
        write(cloned);
        s.source = cloned;
      }
    });
  }

  readSourcePropertyOrDefault<T>(read: (s: IItem) => T, defaultValue: T): T {
    return this.readPropertyOrDefault(s => s.source ? read(s.source) : defaultValue, defaultValue);
  }
}
